import { defineMessages } from 'react-intl';

const messages = defineMessages({
  fieldsetDefault: {
    id: 'Default',
    defaultMessage: 'Default',
  },
  contentType: {
    id: 'Content Type',
    defaultMessage: 'Content Type',
  },
  news: {
    id: 'News',
    defaultMessage: 'News',
  },
  page: {
    id: 'Page',
    defaultMessage: 'Page',
  },
  enablePagination: {
    id: 'Enable pagination',
    defaultMessage: 'Abilita paginazione',
  },
  itemsPerPage: {
    id: 'Items per page',
    defaultMessage: 'Elementi per pagina',
  },
  event: {
    id: 'Event',
    defaultMessage: 'Event',
  },
  place: {  // Aggiungi questo nuovo messaggio
    id: 'Place',
    defaultMessage: 'Luogo',
  },
  attachments: { // Nuovo messaggio per "Allegati"
    id: 'Attachments',
    defaultMessage: 'Allegati',
  },
  totalResults: {
    id: 'Total Results',
    defaultMessage: 'Total Results',
  },
  totalResultsMinError: {
    id: 'Total Results must be at least 1',
    defaultMessage: 'Il numero totale dei risultati deve essere almeno 1',
  },
  resultsPerPage: {
    id: 'Results per Page',
    defaultMessage: 'Results per Page',
  },
  resultsPerPageRangeError: {
    id: 'Results per Page must be between 1 and 10',
    defaultMessage: 'I risultati per pagina devono essere tra 1 e 10',
  },
  sortOrder: {
    id: 'Sort Order',
    defaultMessage: 'Sort Order',
  },
  ascending: {
    id: 'Ascending',
    defaultMessage: 'Ascending',
  },
  descending: {
    id: 'Descending',
    defaultMessage: 'Descending',
  },
  cardStyle: {
    id: 'Card Style',
    defaultMessage: 'Card Style',
  },
  simpleCard: {
    id: 'Simple Card',
    defaultMessage: 'Card Semplice',
  },
  imageCard: {
    id: 'Image Card',
    defaultMessage: 'Card con immagini',
  },
  verticalCard: {
    id: 'Vertical Card',
    defaultMessage: 'Card a tutta colonna',
  },
  attachmentsCard: { // Nuovo messaggio per il card style "Allegati"
    id: 'Attachments Card',
    defaultMessage: 'Card Allegati',
  },
  verticalAlignment: {
    id: 'Vertical Alignment',
    defaultMessage: 'Allineamento contenuti',
  },
  imageLeft: {
    id: 'Image Left',
    defaultMessage: 'Immagine a sinistra',
  },
  imageRight: {
    id: 'Image Right',
    defaultMessage: 'Immagine a destra',
  },
  title: {
    id: 'Title',
    defaultMessage: 'Titolo del blocco',
  },
  showDots: {
    id: 'Show Dots',
    defaultMessage: 'Mostra elementi decorativi',
  },
  yes: {
    id: 'Yes',
    defaultMessage: 'Sì',
  },
  no: {
    id: 'No',
    defaultMessage: 'No',
  },
  dotsPosition: {
    id: 'Dots Position',
    defaultMessage: 'Posizione degli elementi decorativi',
  },
  before: {
    id: 'Before',
    defaultMessage: 'Prima del titolo',
  },
  after: {
    id: 'After',
    defaultMessage: 'Dopo il titolo',
  },
  both: {
    id: 'Both',
    defaultMessage: 'Prima e dopo il titolo',
  },
  titleAlignment: {
    id: 'Title Alignment',
    defaultMessage: 'Allineamento del titolo',
  },
  left: {
    id: 'Left',
    defaultMessage: 'Sinistra',
  },
  center: {
    id: 'Center',
    defaultMessage: 'Centro',
  },
  right: {
    id: 'Right',
    defaultMessage: 'Destra',
  },
});

const blockSchema = (props) => {
  const { intl, data = {} } = props;
  const isVertical = data.cardStyle === 'vertical';
  const showDots = data.showDots === 'yes'; // Mappa "yes" a true

  return {
    title: 'Card List',
    required: ['contentType'],
    fieldsets: [
      {
        id: 'default',
        title: intl.formatMessage(messages.fieldsetDefault),
        fields: [
          'title',
          'showDots',
          ...(showDots ? ['dotsPosition'] : []),
          'titleAlignment',
          'contentType',
          'totalResults',
          'enablePagination', // Aggiungi questo campo
          ...(data.enablePagination ? ['itemsPerPage'] : ['resultsPerPage']), // Mostra uno o l'altro
          'sortOrder',
          'cardStyle',
          ...(isVertical ? ['verticalAlignment'] : []),
        ],
      },
    ],
    properties: {
      title: {
        title: intl.formatMessage(messages.title),
        type: 'string',
        widget: 'text',
      },
      showDots: {
        title: intl.formatMessage(messages.showDots),
        type: 'string',
        widget: 'select',
        choices: [
          ['yes', intl.formatMessage(messages.yes)],
          ['no', intl.formatMessage(messages.no)],
        ],
        default: 'no',
      },
      dotsPosition: {
        title: intl.formatMessage(messages.dotsPosition),
        widget: 'select',
        choices: [
          ['before', intl.formatMessage(messages.before)],
          ['after', intl.formatMessage(messages.after)],
          ['both', intl.formatMessage(messages.both)],
        ],
        default: 'both',
      },
      titleAlignment: {
        title: intl.formatMessage(messages.titleAlignment),
        widget: 'select',
        choices: [
          ['left', intl.formatMessage(messages.left)],
          ['center', intl.formatMessage(messages.center)],
          ['right', intl.formatMessage(messages.right)],
        ],
        default: 'left',
      },
      contentType: {
        title: intl.formatMessage(messages.contentType),
        widget: 'select',
        choices: [
          ['News Item', intl.formatMessage(messages.news)],
          ['Document', intl.formatMessage(messages.page)],
          ['Event', intl.formatMessage(messages.event)],
          ['File', intl.formatMessage(messages.attachments)], // Aggiunto "Allegati"
          ['Luogo', intl.formatMessage(messages.place)],  // Aggiunto "Luogo"
        ],
        default: 'News Item',
      },
      totalResults: {
        title: intl.formatMessage(messages.totalResults),
        type: 'number',
        default: 10,
        minimum: 1,
        validate: (value) =>
          value < 1
            ? [intl.formatMessage(messages.totalResultsMinError)]
            : [],
      },
      resultsPerPage: {
        title: intl.formatMessage(messages.resultsPerPage),
        type: 'number',
        default: 4,
        minimum: 1,
        maximum: 10,
        validate: (value) =>
          value < 1 || value > 10
            ? [intl.formatMessage(messages.resultsPerPageRangeError)]
            : [],
      },
      sortOrder: {
        title: intl.formatMessage(messages.sortOrder),
        widget: 'select',
        choices: [
          ['created|asc', intl.formatMessage(messages.ascending)],
          ['created|desc', intl.formatMessage(messages.descending)],
        ],
        default: 'created|desc',
      },
      cardStyle: {
        title: intl.formatMessage(messages.cardStyle),
        widget: 'select',
        choices: [
          ['simple', intl.formatMessage(messages.simpleCard)],
          ['image', intl.formatMessage(messages.imageCard)],
          ['vertical', intl.formatMessage(messages.verticalCard)],
          ['attachments', intl.formatMessage(messages.attachmentsCard)], // Aggiunto "Allegati"
        ],
        default: 'simple',
      },
      verticalAlignment: {
        title: intl.formatMessage(messages.verticalAlignment),
        widget: 'select',
        choices: [
          ['left', intl.formatMessage(messages.imageLeft)],
          ['right', intl.formatMessage(messages.imageRight)],
        ],
        default: 'left',
      },
      enablePagination: {
        title: intl.formatMessage(messages.enablePagination),
        type: 'boolean',
        default: false,
      },
      itemsPerPage: {
        title: intl.formatMessage(messages.itemsPerPage),
        type: 'number',
        default: 4,
        minimum: 1,
        maximum: 20,
      },
      // Modifica resultsPerPage per essere usato solo senza paginazione
      resultsPerPage: {
        title: intl.formatMessage(messages.resultsPerPage),
        type: 'number',
        default: 4,
        minimum: 1,
        maximum: 100,
      },
    },
  };
};

export default blockSchema;